import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface AdjustCreditsRequest {
    userId: number;
    action: 'add' | 'deduct';
    amount: number;
    description: string;
}

export interface AdjustCreditsResponse {
    success: boolean;
    previousBalance: number;
    newBalance: number;
    message: string;
}

export function useAdjustCredits() {
    const queryClient = useQueryClient();

    return useMutation<AdjustCreditsResponse, Error, AdjustCreditsRequest>({
        mutationFn: ({ userId, action, amount, description }) =>
            api.post(`/api/admin/users/${userId}/credits/adjust`, {
                action,
                amount,
                description,
            }),
        onSuccess: () => {
            // Invalidate admin users queries to refresh balances
            queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
            queryClient.invalidateQueries({ queryKey: ['admin', 'transactions'] });
        },
    });
}
